module.exports = __webpack_public_path__ + "static/janikowo_gdansk-c912c05d9cdeebf9096fc41150b1a144.png";